<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 19H18L16.575 9H7.425L6 19ZM12 7C12.2833 7 12.5208 6.90417 12.7125 6.7125C12.9042 6.52083 13 6.28333 13 6C13 5.71667 12.9042 5.47917 12.7125 5.2875C12.5208 5.09583 12.2833 5 12 5C11.7167 5 11.4792 5.09583 11.2875 5.2875C11.0958 5.47917 11 5.71667 11 6C11 6.28333 11.0958 6.52083 11.2875 6.7125C11.4792 6.90417 11.7167 7 12 7ZM14.825 7H16.575C17.075 7 17.5083 7.16667 17.875 7.5C18.2417 7.83333 18.4667 8.24167 18.55 8.725L19.975 18.725C20.0583 19.325 19.9042 19.8542 19.5125 20.3125C19.1208 20.7708 18.6167 21 18 21H6C5.38333 21 4.87916 20.7708 4.4875 20.3125C4.09583 19.8542 3.94166 19.325 4.025 18.725L5.45 8.725C5.53333 8.24167 5.75833 7.83333 6.125 7.5C6.49166 7.16667 6.925 7 7.425 7H9.175C9.125 6.83333 9.08333 6.67083 9.05 6.5125C9.01666 6.35417 9 6.18333 9 6C9 5.16667 9.29166 4.45833 9.875 3.875C10.4583 3.29167 11.1667 3 12 3C12.8333 3 13.5417 3.29167 14.125 3.875C14.7083 4.45833 15 5.16667 15 6C15 6.18333 14.9833 6.35417 14.95 6.5125C14.9167 6.67083 14.875 6.83333 14.825 7Z"
      fill="black"
    />
  </svg>
</template>
